interface BankProps {
  id: number;
  name: string;
  icon: string;
  code: string;
}

export const bankList: BankProps[] = [
  {
    id: 1,
    name: '국민은행',
    icon: 'bank/KB.png',
    code: '004',
  },
  {
    id: 2,
    name: '신한은행',
    icon: 'bank/SH.png',
    code: '088',
  },
  {
    id: 3,
    name: '하나은행',
    icon: 'bank/HANA.png',
    code: '081'
  },
  {
    id: 4,
    name: '우리은행',
    icon: 'bank/WR.png',
    code: '020',
  },
  {
    id: 5,
    name: 'NH농협은행',
    icon: 'bank/NH.png',
    code: '011',
  },
  {
    id: 6,
    name: '지역농.축협',
    icon: 'bank/NH.png',
    code: '012',
  },
  {
    id: 7,
    name: '기업은행',
    icon: 'bank/IBK.png',
    code: '003',
  },
  {
    id: 8,
    name: '산업은행',
    icon: 'bank/KDB.png',
    code: '002',
  },
  {
    id: 9,
    name: 'SC제일은행',
    icon: 'bank/SC.png',
    code: '023',
  },
  {
    id: 10,
    name: '한국씨티은행',
    icon: 'bank/CITI.png',
    code: '027',
  },
  {
    id: 11,
    name: '부산은행',
    icon: 'bank/BNK.png',
    code: '032',
  },
  {
    id: 12,
    name: '대구은행',
    icon: 'bank/DGB.png',
    code: '031',
  },
  {
    id: 13,
    name: '카카오뱅크',
    icon: 'bank/KAKAO.png',
    code: '090',
  },
  {
    id: 14,
    name: '수협은행',
    icon: 'bank/SUHYUP.png',
    code: '007',
  },
  {
    id: 15,
    name: '경남은행',
    icon: 'bank/BNK.png',
    code: '039',
  },
  {
    id: 16,
    name: '광주은행',
    icon: 'bank/KJ.png',
    code: '034',
  },
  {
    id: 17,
    name: '전북은행',
    icon: 'bank/KJ.png',
    code: '037',
  },
  {
    id: 18,
    name: '제주은행',
    icon: 'bank/SH.png',
    code: '035',
  },
  {
    id: 19,
    name: '새마을금고',
    icon: 'bank/KFC.png',
    code: '045',
  },
  {
    id: 20,
    name: '신협',
    icon: 'bank/CU.png',
    code: '048'
  },
  {
    id: 21,
    name: '우체국',
    icon: 'bank/PO.png',
    code: '071'
  },
  // 임시 제거 https://heumlabs.atlassian.net/browse/OVERTAX-1151
  // {
  //   id: 20,
  //   name: '산림조합',
  //   icon: getImageUrl('bank/SJ.png'),
  // },
  // 임시 제거 https://heumlabs.atlassian.net/browse/OVERTAX-1151
  // {
  //   id: 22,
  //   name: '저축은행',
  //   icon: getImageUrl('bank/SB.png'),
  // },
]
